export default __webpack_public_path__ + "static/media/social-banner.1a12a787.jpg";